<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="footer-info">
        厚生労働省大臣認可　13-ユ-304437
        <br />
        エムスリーキャリア株式会社 〒105-0001 東京都港区虎ノ門４-１-２８
      </div>
      <ul class="footer-nav">
        <li><a href="/terms" target="_blank" rel="noopener noreferrer">利用規約</a></li>
        <li><a href="https://www.m3career.com/privacy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a></li>
        <li><a href="https://www.m3career.com/company/company-profile/" target="_blank" rel="noopener noreferrer">会社概要</a></li>
      </ul>
    </div>
    <div class="copy">Copyright 2025 M3 Career, Inc. All Rights Reserved.</div>
  </footer>
</template>

<script>
export default {
  name: 'LpFooter'
}
</script>
